module.exports = "/components/components/manageAvailabilityComponent-02539e.html";